var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-table" },
    [
      _c(
        "ma-modal",
        { ref: "adminEditModal", attrs: { type: "small" } },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c("p", { staticClass: "headline-large mg mg--b-1 black" }, [
                _vm._v(_vm._s(_vm.$t("reparations.title")))
              ]),
              _c(
                "div",
                { staticClass: "grid mg mg--t-4" },
                [
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminReparationRepTypeCode",
                      col: 2,
                      icon: "house",
                      literal: "reparations.table.repTypeCode",
                      disabled: "",
                      value: _vm.reparation.repTypeCode
                    }
                  }),
                  _vm.damagestypesOptions
                    ? _c("ma-input-select", {
                        attrs: {
                          type: "select",
                          name: "adminReparationDamagesType",
                          col: 2,
                          icon: "house",
                          literal: "reparations.table.damagesType",
                          options: _vm.damagestypesOptions,
                          value: _vm.reparation.damagesType
                        },
                        on: {
                          change: function($event) {
                            _vm.reparation.damagesType = $event
                          }
                        }
                      })
                    : _vm._e(),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminReparationDescription",
                      col: 2,
                      icon: "house",
                      literal: "reparations.table.description",
                      disabled: ""
                    },
                    model: {
                      value: _vm.reparation.description,
                      callback: function($$v) {
                        _vm.$set(_vm.reparation, "description", $$v)
                      },
                      expression: "reparation.description"
                    }
                  }),
                  _vm.surfaceUnitsOptions
                    ? _c("ma-input-select", {
                        attrs: {
                          type: "select",
                          name: "adminReparationSurfaceUnit",
                          col: 2,
                          icon: "house",
                          literal: "reparations.table.surfaceUnit",
                          options: _vm.surfaceUnitsOptions,
                          value: _vm.reparation.surfaceUnit
                        },
                        on: {
                          change: function($event) {
                            _vm.reparation.surfaceUnit = $event
                          }
                        }
                      })
                    : _vm._e(),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminReparationPriceCalcForm",
                      col: 2,
                      icon: "house",
                      literal: "reparations.table.priceCalcForm"
                    },
                    model: {
                      value: _vm.reparation.priceCalcForm,
                      callback: function($$v) {
                        _vm.$set(_vm.reparation, "priceCalcForm", $$v)
                      },
                      expression: "reparation.priceCalcForm"
                    }
                  }),
                  _vm.reparationsTypesOptions
                    ? _c("ma-input-select", {
                        attrs: {
                          type: "select",
                          name: "adminReparationType",
                          col: 2,
                          icon: "house",
                          literal: "reparations.table.type",
                          options: _vm.reparationsTypesOptions,
                          value: _vm.reparation.type
                        },
                        on: {
                          change: function($event) {
                            _vm.reparation.type = $event
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  on: { click: _vm.handleSave }
                },
                [_vm._v(_vm._s(_vm.$t("actions.save")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue",
                  on: { click: _vm.handleCancel }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              )
            ])
          ])
        ],
        2
      ),
      _c("p", { staticClass: "mg mg--b-4 mg--t-4 headline-large" }, [
        _vm._v(_vm._s(_vm.$t("reparations.title")))
      ]),
      _c("div", { staticClass: "grid" }, [
        _c(
          "div",
          { staticClass: "grid__cell-md-2" },
          [
            _c("ma-filters", {
              on: { "filter:change": _vm.handleFiltersChange }
            })
          ],
          1
        )
      ]),
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c("tr", { staticClass: "bg-blueDark" }, [
            _c("th", { staticClass: "border-right", attrs: { width: "18%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("reparations.table.repTypeCode")))
              ])
            ]),
            _c("th", { staticClass: "border-right", attrs: { width: "18%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("reparations.table.damagesType")))
              ])
            ]),
            _c("th", { staticClass: "border-right", attrs: { width: "18%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("reparations.table.description")))
              ])
            ]),
            _c("th", { staticClass: "border-right", attrs: { width: "18%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("reparations.table.surfaceUnit")))
              ])
            ]),
            _c("th", { staticClass: "border-right", attrs: { width: "18%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("reparations.table.priceCalcForm")))
              ])
            ]),
            _c("th", { staticClass: "no--border", attrs: { width: "18%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("reparations.table.type")))
              ])
            ]),
            _vm.canEdit
              ? _c("th", {
                  staticClass: "border-right",
                  attrs: { width: "20px" }
                })
              : _vm._e()
          ])
        ]),
        _vm.hasData
          ? _c(
              "tbody",
              _vm._l(_vm.table, function(row) {
                return _c("tr", [
                  _c("td", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium black" }, [
                      _vm._v(_vm._s(row.rep_type_code))
                    ])
                  ]),
                  _c("td", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium black" }, [
                      _vm._v(_vm._s(row.damages_type))
                    ])
                  ]),
                  _c("td", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium black" }, [
                      _vm._v(_vm._s(row.description))
                    ])
                  ]),
                  _c("td", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium black" }, [
                      _vm._v(_vm._s(row.surface_unit))
                    ])
                  ]),
                  _c("td", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium black" }, [
                      _vm._v(_vm._s(row.price_calc_form))
                    ])
                  ]),
                  _c("td", { staticClass: "no--border" }, [
                    _c("p", { staticClass: "text-medium black" }, [
                      _vm._v(_vm._s(row.type))
                    ])
                  ]),
                  _vm.canEdit
                    ? _c(
                        "td",
                        { staticClass: "text-align--right" },
                        [
                          _c("svgicon", {
                            staticClass: "svg-icon-action",
                            attrs: { name: "edit", height: "16", widht: "16" },
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(
                                  row.rep_type_code,
                                  row.damages_type,
                                  row.description,
                                  row.surface_unit,
                                  row.price_calc_form,
                                  row.type
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e()
      ]),
      _vm.hasData
        ? _c(
            "div",
            { staticClass: "grid grid--jc-bottom mg mg--t-4" },
            [
              _c("ma-paginator", {
                staticClass: "mg mg--t-2 mg--b-4",
                attrs: { current: _vm.currentPage, total: _vm.totalPages },
                on: {
                  "page:update": _vm.handlePageUpdate,
                  "page:set": _vm.handlePageSet
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.hasData
        ? _c("ma-empty", {
            attrs: {
              icon: "recherche",
              title: _vm.$t("common.noresults.short"),
              descr: _vm.$t("common.noresults.long")
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }